"use strict";

import documentDownload from "./documentdownload";

const diasConfigurable = angular.module("dias.configurable", [
  documentDownload.name
]);

export default diasConfigurable;
